<template>
  <v-card>
    <GenericListTable
      :parentID="this.parentID"
      :title="`Devices`"
      :headers="[
        { text: 'ID', value: 'id' },
        { text: 'Device ID', value: 'devicename' },
        { text: 'Last Message Timestamp', value: 'datatime' },
        { text: 'Last Message Data', value: 'databytes' },
        { text: 'Device Location', value: 'identity_data.displayname', value2: 'displayname'},
        { text: 'Latitude', value: 'identity_data.loc_lat' },
        { text: 'Longitude', value: 'identity_data.loc_lon' }
      ]"
      :url="`/schemas/devices`"
      :apiResponseField="`devices`"
      :onClickRoute="`DeviceTypeGraph`"
      :onClickParams="getOnClickParams"
      :onClickQuery="getOnClickQuery">
    </GenericListTable>
  </v-card>
</template>

<script>
import moment from 'moment'
import GenericListTable from '@/components/Common/GenericListTable'

export default {
  name: 'DeviceListTable',
  components: { GenericListTable },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  methods: {
    getOnClickParams (item) {
      return {
        deviceID: item.devicename,
        displayname: item.identity_data.displayname,
        devicetype: item.typename
      }
    },
    getOnClickQuery (item) {
      return {
        datefrom: moment().subtract(30, 'days')
          .format('YYYYMMDD000000'),
        dateto: moment().format('YYYYMMDD235959')
      }
    }
  }
}
</script>
